import React, { Component, lazy } from "react";
import "./AdminCore.css";
import AdminSidebar from "./Components/AdminSidebar/AdminSidebar";
import { AnimatePresence } from "framer-motion";
import ConfirmationNotification from "../../Util/ConfirmationNotification/ConfirmationNotification";
import JSONpackage from "../../../package.json";
import AdminFilters from "./Components/AdminFilters/AdminFilters";
import getFilteredPhoneNumber from "../../Util/GetFilteredPhoneNumber/GetFilteredPhoneNumber";
import SendTextMessage from "./Components/AdminSales/Components/SendTextMessage/SendTextMessage";
import AddCouponItems from "./Components/AdminCoupons/Components/AddCouponItems/AddCouponItems";
import CustomerTextHistory from "./Components/AdminSales/Components/CustomerHistory/Components/CustomerTextHistory/CustomerTextHistory";
import { Redirect, Route, withRouter } from "react-router-dom";
import { Suspense } from "react";
import MessageContainer from "./Components/Users/User/MessageContainer/MessageContainer";
import Leagues from "./Components/AdminLeagues/Leagues";
import ContactUs from "./Components/AdminContactUs/AdminContactUs";
import TextLogs from "./Components/AdminTextLogs/TextLogs";
import { store } from "../../Store/Store";
import NewCouponDetails from "./Components/AdminCoupons/Components/CouponDetails/NewCouponDetails";
import AdminTransactions from './Components/AdminTransactions/AdminTransaction';
import AdminCoupons from "./Components/AdminCoupons/NewAdminCoupons";
import AdminMenu from "./Components/AdminMenu/NewAdminMenu";
import AdminEvents from './Components/AdminEvents/AdminEvents';
import Users from "./Components/Users/Users";
import PermissionGuard from '../../core/guard/PermissionGuard';
import ToolsAndSettings from "./Components/ToolsAndSettings/ToolsAndSettings";
import ModifyHours from "./Components/ToolsAndSettings/Orders/Components/ModifyHours/ModifyHours";
import AddEventHeadline from './Components/AdminEvents/WebsiteContent/AddEventHeadline';
import WebsiteContent from './Components/AdminEvents/WebsiteContent/WebsiteContent';
import Leads from './Components/AdminEvents/Leads/Leads';
import Invoices from './Components/AdminEvents/Invoices/Invoices';
import AddLead from './Components/AdminEvents/Leads/Lead/AddLead';
import CreateDocuments from './Components/AdminEvents/Documents/AddEditDocuments';
import Events from "./Components/AdminEvents/Events/Events";
import AddEvent from "./Components/AdminEvents/Events/AddEvent";
import InvoiceListing from "./Components/AdminEvents/InvoiceListing/InvoiceListing";
import AdminRedirect from "../CustomerPages/AdminRedirect";
//const AdminMenu = lazy(() => import("./Components/AdminMenu/AdminMenu"));
const AdminSales = lazy(() => import("./Components/AdminSales/AdminSales"));
const AdminEmail = lazy(() => import("./Components/AdminEmail/AdminEmail"));
const AdminTools = lazy(() => import("./Components/ToolsAndSettings/Orders/AdminTools"));
const EventDocuments = lazy(() => import("./Components/AdminEvents/Documents/Document"));
const EventCalendar = lazy(() => import("./Components/AdminEvents/Calendar/Calendar"));
const ScanedTickets = lazy(() => import("./Components/AdminEvents/ScanedTickets/ScanTickets"));


class AdminCore extends Component {
	constructor() {
		super();
		this.state = {
			currentPage: 0,
			itemDrawerDisplayed: false,
			displayModifyHours: false,
			displayNotification: false,
			notificationHeader: "",
			notificationBody: "",
			notificationConfirmFunction: () => null,
			selectedItemIsNew: false,
			originalSelectedItem: {},
			selectedItem: {
				description: "",
				exceptions: 0,
				id: 0,
				image: "",
				itemAvailable: true,
				name: "",
				price: 8,
				sectionIndex: 0,
				exception: [
					{
						exceptionButton: "Next",
						exceptionDescription: [],
						exceptionInput: [],
						exceptionInputPrices: [],
						exceptionText: "",
					},
				],
			},
			sectionSelected: 0,
			menu: [],
			continuousMenu: [],
			orderHistory: [],
			fetchingRecentOrders: false,
			nextYearToQuery: new Date().getFullYear(),
			nextMonthToQuery: new Date().getMonth() + 1,
			quotes: [],
			drivers: [],
			enableDelivery: true,
			enablePickup: true,
			newOrders: [],
			route: "",
			gotMenu: false,
			hoursOfOperation: [],
			clientHoursOfOperation: [],
			displayFilters: false,
			filteredOrderList: [],
			filters: {
				delivery: false,
				pickup: false,
				minimumItemQuantity: false,
				minimumOrderPrice: false,
				minimumTimesOrdered: false,
				itemsPurchased: [{ selected: false, selectedItemIndex: 0 }],
				selectedTimesOrderedAmount: 0,
				minimumOrderPriceSelected: 0,
				selectedItemQuantity: 0,
				continuousMenu: [],
			},
			filterString: "",
			sales: {
				totalSales: 0,
				deliverySales: 0,
				pickupSales: 0,
				totalTips: 0,
			},
			graphData: {
				datasets: [
					{
						label: "Sales",
						data: [0, 0, 0],
						backgroundColor: ["#00788B", "#104c57", "#00BCD9"],
					},
				],
				labels: ["Tips", "Pickup", "Delivery"],
			},
			sendTextMessage: false,
			phoneNumberList: [],
			orderMonthsGotten: 0,
			monthByMonthOrders: [],
			currentTimeframe: 0,
			createCoupon: false,
			coupons: [],
			addItemsToCoupon: false,
			addItemsToCouponCallback: () => { },
			itemsRequiredForCoupon: [],
			displayCustomerTextHistory: false,
			textCustomerInfo: {
				phoneNumber: "",
				name: "",
			},
			textMessageHistory: {},
			emails: [],
			subscription: null,
		};
	}

	componentDidMount() {
		if (!this.state.fetchingRecentOrders) {
			this.getYearsOrders();
		}
		this.getQuotesHandler();
		this.getProductionHandler();

		this.setState({
			subscription: store.subscribe(() => {
				this.setState({
					copyLeague: store.getState().copyLeague.value,
				});
			})
		});
	}

	componentWillUnmount() {
		if (this.state.subscription && this.state.subscription.unsubscribe) {
			this.state.subscription.unsubscribe();
		}
	}

	getEmails = () => {
		fetch(`${this.state.route}/api/getMail`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		})
			.then((response) => {
				return response.text();
			})
			.then((response) => {
				this.setState({ emails: JSON.parse(response).value });
			})
			.catch((error) => {
				this.displayMessageHandler("Failed to get email");
			});
	};

	getQuotesHandler = () => {
	};

	getTwoDigitStringFromNumber = (number) => {
		let newString = `${number}`;
		if (newString.length === 1) newString = "0" + newString;
		return newString;
	};

	getProductionHandler = () => {
		if (JSONpackage.production) {
			this.setState({ route: "https://BigMPizza.com:443" }, () => {
				this.getDriversHandler();
				// this.getEmails();
			});
		} else {
			this.setState({ route: "http://localhost:4000" }, () => {
				this.getDriversHandler();
				// this.getEmails();
			});
		}
	};

	getDriversHandler = () => {
		// axios
		//   .get(`${this.state.route}/api/getUserList`)
		//   .then((response) => {
		//     this.getLoggedInDriversHandler(response.data);
		//   })
		//   .catch(() => this.displayMessageHandler("Failed to get drivers"));
	};

	getLoggedInDriversHandler = (passedDrivers) => {
	};

	reduceNextMonthHandler = () => {
		let nextMonth = this.state.nextMonthToQuery - 1;
		if (nextMonth === 0) {
			this.setState({
				nextMonthToQuery: 12,
				nextYearToQuery: this.state.nextYearToQuery - 1,
			});
		} else {
			this.setState({ nextMonthToQuery: nextMonth });
		}
	};

	getOrderedArrayFromEntries = (array) => {
		let newArray = array.map((value, index) => [Number(value[0]), value[1]]);
		let sortedArray = newArray.sort((a, b) => b[0] - a[0]);
		return sortedArray;
	};

	getRecentOrders = async () => {
		this.setState({ fetchingRecentOrders: true });
	};

	getYearsOrders = async () => {
		this.setState({ fetchingRecentOrders: true });
	};

	getCurrentlyDisplayedOrders = () => {
		let yearByYearOrders = [...this.state.monthByMonthOrders];
		let arrayOfMonthsOrders = [];
		yearByYearOrders.forEach((year, yearIndex) => {
			year.forEach((month, monthIndex) => arrayOfMonthsOrders.push(month));
		});
		let timeframes = [1, 3, 6, 12, arrayOfMonthsOrders.length];
		let timeframe =
			timeframes[this.state.currentTimeframe] < arrayOfMonthsOrders.length
				? timeframes[this.state.currentTimeframe]
				: arrayOfMonthsOrders.length;
		let currentOrders = [];
		for (let i = 0; i < timeframe; ++i) {
			let days = Object.entries(
				arrayOfMonthsOrders[arrayOfMonthsOrders.length - 1 - i][1]
			);
			let sortedDays = this.getOrderedArrayFromEntries(days);
			sortedDays.forEach((sortedDay, index) => {
				let daysOrders = [...sortedDay[1]];
				daysOrders.reverse();
				currentOrders.push(...daysOrders);
			});
		}
		this.getTotalSalesHandler(currentOrders);
		let filteredOrderList = this.filterOrdersByStringHandler(
			this.state.filterString,
			this.getFilteredOrderHistoryHandler(this.state.filters, currentOrders)
		);
		this.setState({ filteredOrderList, currentOrderList: currentOrders });
	};

	updateTimeframeHandler = (newTimeframe) => {
		this.setState({ currentTimeframe: newTimeframe }, () =>
			this.getCurrentlyDisplayedOrders()
		);
	};

	getTotalSalesHandler = (orderHistory) => {
		let totalSales = 0;
		let deliverySales = 0;
		let pickupSales = 0;
		let totalTips = 0;
		orderHistory.forEach((value, index) => {
			let tip = value.tip ? value.tip : 0;
			totalSales += value.orderPrice;
			totalTips += tip;
			if (value.delivery) {
				deliverySales += value.orderPrice - tip;
			} else {
				pickupSales += value.orderPrice - tip;
			}
		});
		let sales = {
			totalSales,
			deliverySales,
			pickupSales,
			totalTips,
		};

		let graphData = {
			datasets: [
				{
					label: "Sales",
					data: [
						totalTips.toFixed(2),
						pickupSales.toFixed(2),
						deliverySales.toFixed(2),
					],
					backgroundColor: ["#00788B", "#104c57", "#00BCD9"],
				},
			],
			labels: ["Tips", "Pickup", "Delivery"],
		};
		this.setState({ sales, graphData });
	};

	changePage = (newPage) => {
		this.setState({ currentPage: newPage });
	};

	newItem = {
		description: "",
		exceptions: 0,
		id: 0,
		image: "",
		itemAvailable: true,
		name: "",
		price: 0,
		sectionIndex: 0,
		exception: [],
	};

	displayItemDrawer = (reset) => {
		if (reset) {
			if (this.state.menu[this.state.selectedItem.sectionIndex].menuItem) {
				this.setState({
					selectedItem:
						this.state.menu[this.state.selectedItem.sectionIndex]?.menuItem[
						this.state.selectedItem.id
						],
					itemDrawerDisplayed: !this.state.itemDrawerDisplayed,
				});
			} else {
				this.setState({ itemDrawerDisplayed: !this.state.itemDrawerDisplayed });
			}
		} else {
			this.setState({ itemDrawerDisplayed: !this.state.itemDrawerDisplayed });
		}
	};

	getNewItemIdHandler = (sectionIndex) => {
		let length = this.state.menu[sectionIndex].menuItem?.length;
		for (let i = 0; i < length; i++) {
			let foundFlag = false;
			for (let j = 0; j < length; j++) {
				if (this.state.menu[sectionIndex].menuItem[j]?.id === i) {
					foundFlag = true;
					break;
				}
			}
			if (foundFlag === false) {
				return i;
			}
		}
		return length ? length : 0;
	};

	setItemDrawerDisplay = (itemDetails = this.newItem, sectionIndex) => {
		if (itemDetails === this.newItem) {
			let newItemId = this.getNewItemIdHandler(sectionIndex);
			let newItem = itemDetails;
			newItem.sectionIndex = sectionIndex;
			newItem.id = newItemId;
			this.setState({
				itemDrawerDisplayed: !this.state.itemDrawerDisplayed,
				selectedItem: newItem,
				originalSelectedItem: newItem,
				selectedItemIsNew: true,
			});
		} else {
			this.setState({
				itemDrawerDisplayed: !this.state.itemDrawerDisplayed,
				selectedItem: itemDetails,
				originalSelectedItem: itemDetails,
				selectedItemIsNew: false,
			});
		}
	};

	displayConfirmationNotification = (header, body, confirmFunction) => {
		this.setState({
			displayNotification: true,
			notificationHeader: header,
			notificationBody: body,
			notificationConfirmFunction: confirmFunction,
		});
	};

	closeConfirmationHandler = () => {
		this.setState({ displayNotification: false });
	};

	displayModifyHoursHandler = () => {
		this.setState({ displayModifyHours: !this.state.displayModifyHours });
	};

	displayFiltersHandler = () => {
		this.setState({ displayFilters: !this.state.displayFilters });
	};

	displayMessageHandler = (message) => {
		// toast(`${message}`, {
		//   className: "errorToastNotification",
		//   bodyClassName: "errorToastBody",
		//   progressClassName: "errorToastProgressBar",
		// });
	};

	updateFiltersHandler = (filters) => {
		this.setState({ filters }, () => this.getCurrentlyDisplayedOrders());
	};

	removeZerosFromDate = (date) => {
		let dateArray = date.split("/");
		return `${Number(dateArray[0])}/${Number(dateArray[1])}/${dateArray[2]}`;
	};

	getFilteredOrderHistoryHandler = (
		filters,
		orderHistory = [...this.state.currentOrderList]
	) => {
		const getDeliveryHandler = (tempOrderHistory) => {
			let updatedOrderHistory = [];
			tempOrderHistory.forEach((value, index) => {
				if (value.delivery) {
					updatedOrderHistory.push(value);
				}
			});
			return updatedOrderHistory;
		};

		const getPickupHandler = (tempOrderHistory) => {
			let updatedOrderHistory = [];
			tempOrderHistory.forEach((value, index) => {
				if (!value.delivery) {
					updatedOrderHistory.push(value);
				}
			});
			return updatedOrderHistory;
		};

		const getMinimumItemQuantityHandler = (tempOrderHistory) => {
			let updatedOrderHistory = [];
			tempOrderHistory.forEach((value, index) => {
				let itemQuantity = 0;
				value.orderItems.forEach((itemValue, itemIndex) => {
					itemQuantity += itemValue.quantity;
				});
				if (itemQuantity >= filters.selectedItemQuantity) {
					updatedOrderHistory.push(value);
				}
			});
			return updatedOrderHistory;
		};

		const getMinimumOrderPriceHandler = (tempOrderHistory) => {
			let updatedOrderHistory = [];
			tempOrderHistory.forEach((value, index) => {
				if (value.orderPrice >= filters.minimumOrderPriceSelected * 10) {
					updatedOrderHistory.push(value);
				}
			});
			return updatedOrderHistory;
		};

		const getItemsHandler = (tempOrderHistory, selectedItemIndex) => {
			let updatedOrderHistory = [];
			tempOrderHistory.forEach((order, orderIndex) => {
				if (
					order.orderItems.some(
						(orderItem, orderItemIndex) =>
							filters.continuousMenu[selectedItemIndex] === orderItem.item
					)
				) {
					if (
						updatedOrderHistory.every(
							(value, index) => value.orderName !== order.orderName
						)
					) {
						updatedOrderHistory.push(order);
					}
				}
			});
			return updatedOrderHistory;
		};

		const getOrderAmountHandler = (tempOrderHistory) => {
			let updatedOrderHistory = [];
			let finalOrderHistory = [];
			tempOrderHistory.forEach((order, orderIndex) => {
				let indexFound = -1;
				if (
					updatedOrderHistory.some((value, index) => {
						if (
							value.orderInfo.orderPhoneNumber === order.orderPhoneNumber &&
							order.orderPhoneNumber !== ""
						) {
							indexFound = index;
							return true;
						}
						return false;
					})
				) {
					updatedOrderHistory[indexFound].ordersPlaced++;
				} else {
					updatedOrderHistory.push({ ordersPlaced: 1, orderInfo: order });
				}
			});
			updatedOrderHistory.forEach((value, index) => {
				if (value.ordersPlaced > filters.selectedTimesOrderedAmount) {
					finalOrderHistory.push(value.orderInfo);
				}
			});
			return finalOrderHistory;
		};

		if (filters.delivery) {
			orderHistory = getDeliveryHandler(orderHistory);
		}
		if (filters.pickup) {
			orderHistory = getPickupHandler(orderHistory);
		}
		if (filters.minimumItemQuantity) {
			orderHistory = getMinimumItemQuantityHandler(orderHistory);
		}
		if (filters.minimumTimesOrdered) {
			orderHistory = getOrderAmountHandler(orderHistory);
		}
		if (filters.minimumOrderPrice) {
			orderHistory = getMinimumOrderPriceHandler(orderHistory);
		}
		if (filters.itemsPurchased.some((value, index) => value.selected)) {
			filters.itemsPurchased.forEach((value) => {
				if (value.selected) {
					orderHistory = getItemsHandler(orderHistory, value.selectedItemIndex);
				}
			});
		}
		return orderHistory;
	};

	filterOrdersByStringHandler = (filterString, orderHistory) => {
		let newOrderList = [];
		let searchString = filterString.toLowerCase();
		orderHistory.forEach((order, index) => {
			let filteredPhoneNumber = order.orderPhoneNumber
				? getFilteredPhoneNumber(order.orderPhoneNumber)
				: "";
			let stringOrderNumber = `${order.orderNumber}`;
			if (
				this.removeZerosFromDate(order.date).includes(searchString) ||
				order.orderName.toLowerCase().includes(searchString) ||
				filteredPhoneNumber.includes(searchString) ||
				stringOrderNumber.includes(searchString)
			) {
				newOrderList.push(order);
			}
		});
		return newOrderList;
	};

	updateFilterString = (filterString) => {
		let orderHistory = this.getFilteredOrderHistoryHandler(this.state.filters);
		let newOrderList = this.filterOrdersByStringHandler(
			filterString,
			orderHistory
		);
		this.setState({ filterString, filteredOrderList: newOrderList });
	};

	updateFilteredOrderList = (newOrderList) => {
		this.setState({ filteredOrderList: newOrderList });
	};

	sendTextMessageHandler = (selectedCustomerList) => {
		this.setState({
			sendTextMessage: true,
			phoneNumberList: selectedCustomerList,
		});
	};

	saveCouponHandler = (coupon) => {
		let coupons = this.state.coupons;
		coupons.unshift(coupon);
		this.setState({ coupons }, () =>
			this.displayMessageHandler("Coupon Created Successfully")
		);
	};

	displayCustomerTextHistoryHandler = (phoneNumber, name) => {
		let textCustomerInfo = {
			phoneNumber,
			name,
		};
		this.setState({ displayCustomerTextHistory: true, textCustomerInfo });
	};

	updateMassTextHistory = (recipients, message) => {
		let textMessageHistory = { ...this.state.textMessageHistory };
		let date = new Date();
		recipients.forEach((value, index) => {
			if (textMessageHistory[`${value.phoneNumber}`]) {
				textMessageHistory[`${value.phoneNumber}`].push({
					message,
					date: `${date}`,
				});
			} else {
				textMessageHistory[`${value.phoneNumber}`] = [
					{
						message,
						date: `${date}`,
					},
				];
			}
		});
	};

	render() {
		return (
			<div className={`adminPageContainer ${this.state.copyLeague && ' copy-league-overlay'}`}>
				<AnimatePresence>
					{this.state.addItemsToCoupon && (
						<AddCouponItems
							key="sofij0sduf09suf"
							menu={this.state.menu}
							coupons={this.state.coupons}
							itemsRequiredForCoupon={this.state.itemsRequiredForCoupon}
							addItemsToCouponCallback={this.state.addItemsToCouponCallback}
							closeAddItems={() => this.setState({ addItemsToCoupon: false })}
						/>
					)}
				</AnimatePresence>
				<AnimatePresence>
					{this.state.sendTextMessage && (
						<SendTextMessage
							key="0sdi9fj09wuefjdf"
							updateMassTextHistory={this.updateMassTextHistory}
							phoneNumberList={this.state.phoneNumberList}
							closeWindow={() => this.setState({ sendTextMessage: false })}
							displayConfirmationNotification={
								this.displayConfirmationNotification
							}
							displayMessageHandler={this.displayMessageHandler}
						/>
					)}
				</AnimatePresence>
				<AnimatePresence>
					{this.state.displayFilters && (
						<AdminFilters
							filters={this.state.filters}
							updateFiltersHandler={this.updateFiltersHandler}
							updateFilteredOrderList={this.updateFilteredOrderList}
							orderHistory={this.state.orderHistory}
							menu={this.state.menu}
							displayFiltersHandler={this.displayFiltersHandler}
						/>
					)}
				</AnimatePresence>
				<AnimatePresence>
					{this.state.displayModifyHours && (
						<ModifyHours
							key="sjdfu0990rkj023"
							hoursOfOperation={this.state.hoursOfOperation}
							displayMessageHandler={this.displayMessageHandler}
							displayModifyHours={this.displayModifyHoursHandler}
						/>
					)}
				</AnimatePresence>
				<AnimatePresence>
					{this.state.displayCustomerTextHistory && (
						<CustomerTextHistory
							key="sdfoijs0duf0s9udfsdf09iu"
							textHistory={
								this.state.textMessageHistory
									? this.state.textMessageHistory[
									`${this.state.textCustomerInfo.phoneNumber} `
									]
									: []
							}
							route={this.state.route}
							displayMessageHandler={this.displayMessageHandler}
							customerInfo={this.state.textCustomerInfo}
							closeDisplay={() =>
								this.setState({ displayCustomerTextHistory: false })
							}
						/>
					)}
				</AnimatePresence>
				<AdminSidebar
					currentPage={this.state.currentPage}
					changePage={this.changePage}
					logout={this.props.changePage}
				/>
				<AnimatePresence exitBeforeEnter>
					<Suspense>
						<Route path={`${this.props.match.path} /`}>
							<AdminRedirect />
						</Route >
						<Route path={`${this.props.match.path}/contact-us`}>
							<ContactUs />
						</Route>
						<Route path={`${this.props.match.path}/sms-logs`}>
							<TextLogs />
						</Route>
						{/* <Route path={`${this.props.match.path}/menu`}>
							<PermissionGuard type={'menu'} Component={AdminMenu} />
						</Route> */}
						<Route path={`${this.props.match.path}/sales`}>
							<AdminSales
								displayCustomerTextHistory={
									this.displayCustomerTextHistoryHandler
								}
								key="r293hf902ijh34fg02"
								menu={this.state.continuousMenu}
								currentTimeframe={this.state.currentTimeframe}
								updateTimeframe={this.updateTimeframeHandler}
								sendTextMessage={this.state.sendTextMessage}
								sendTextMessageHandler={this.sendTextMessageHandler}
								graphData={this.state.graphData}
								sales={this.state.sales}
								filterString={this.state.filterString}
								updateFilterString={this.updateFilterString}
								updateFilteredOrderList={this.updateFilteredOrderList}
								filteredOrderList={this.state.filteredOrderList}
								displayFiltersHandler={this.displayFiltersHandler}
								getRecentOrders={this.getRecentOrders}
								orderHistory={this.state.orderHistory}
								fetchingRecentOrders={this.state.fetchingRecentOrders}
							/>
						</Route>
						
						<Route path={`${this.props.match.path}/events/website-content`}>
							<WebsiteContent />
						</Route>
						<Route path={`${this.props.match.path}/events/leads`} exact>
							<Leads />
						</Route>
						<Route path={`${this.props.match.path}/events/invoices`}>
							<Invoices />
						</Route>
						<Route path={`${this.props.match.path}/events/leads/add`} exact>
							<AddLead />
						</Route>
						<Route path={`${this.props.match.path}/events/leads/edit/:id`} exact>
							<AddLead />
						</Route>
						<Route path={`${this.props.match.path}/events/event-headline`}>
							<AddEventHeadline />
						</Route>
						<Route path={`${this.props.match.path}/events/event-inclusion`}>
							<AddEventHeadline />
						</Route>
						<Route path={`${this.props.match.path}/events/documents`} exact>
							<EventDocuments />
						</Route>
						<Route path={`${this.props.match.path}/events/documents/edit/:id`}>
							<CreateDocuments />
						</Route>
						<Route path={`${this.props.match.path}/events/documents/add`}>
							<CreateDocuments />
						</Route>
						<Route path={`${this.props.match.path}/events`} exact>
							<Events />
						</Route>
						<Route path={`${this.props.match.path}/events/add`} exact>
							<AddEvent />
						</Route>
						<Route path={`${this.props.match.path}/events/edit/:id`} exact>
							<AddEvent />
						</Route>
						<Route path={`${this.props.match.path}/events/calendar`} exact>
							<EventCalendar />
						</Route>
						<Route path={`${this.props.match.path}/events/all-invoices`} exact>
							<InvoiceListing />
						</Route>
						<Route path={`${this.props.match.path}/events/public-events`} exact>
							<Events type={'public-events'} />
						</Route>
						<Route path={`${this.props.match.path}/events/public-events/:id`} exact>
							<ScanedTickets />
						</Route>
						{/* <Route path={`${this.props.match.path}/coupons`} exact> */}
						{/* <Route path={`${this.props.match.path}/coupons`} exact>
							<PermissionGuard type={'coupons'} Component={AdminCoupons} key='guard-coupons' />
						</Route> */}
						{/* <Route path={`${this.props.match.path}/coupons/:id`} >
							<NewCouponDetails />
						</Route> */}
						<Route path={`${this.props.match.path}/events`}>
							<PermissionGuard type={'event-page'} Component={AdminEvents} key='guard-events' />
						</Route>
						<Route path={`${this.props.match.path}/email`}>
							<AdminEmail
								key="adminEmailPage"
								route={this.state.route}
								emails={this.state.emails}
							/>
						</Route>
						<Route path={`${this.props.match.path}/settings`}>
							<PermissionGuard type='settings' Component={ToolsAndSettings} key='guard-settings' />
							<Route path={`${this.props.match.path}/settings/order`}>
								<AdminTools
									key="w9ehjf902j3fiji04f"
									displayMessageHandler={this.displayMessageHandler}
									drivers={this.state.drivers}
									getDriversHandler={this.getDriversHandler}
									newOrders={this.state.newOrders}
									announcement={this.state.announcement}
									enableDelivery={this.state.enableDelivery}
									enablePickup={this.state.enablePickup}
									menu={this.state.menu}
									getQuotesHandler={this.getQuotesHandler}
									quotes={this.state.quotes}
									displayModifyHours={this.displayModifyHoursHandler}
									displayConfirmationNotification={
										this.displayConfirmationNotification
									}
								/>
							</Route>
						</Route>
						<Route path={`${this.props.match.path}/users`}>
							<PermissionGuard type={'users'} Component={Users} key="adminUsersPage" />
						</Route>
						<Route path={`${this.props.match.path}/send-email`}>
							<MessageContainer type={'email'} />
						</Route>
						<Route path={`${this.props.match.path}/send-sms`}>
							<MessageContainer type={'text'} />
						</Route>
						<Route path={`${this.props.match.path}/leagues`}>
							<PermissionGuard type={'leagues'} Component={Leagues} key='guard-leagues' />
						</Route>
						<Route path={`${this.props.match.path}/transactions`}>
							<PermissionGuard type={'transactions'} Component={AdminTransactions} key='guard-transactions' />
						</Route>
					</Suspense >
				</AnimatePresence >
				<AnimatePresence>
					{this.state.displayNotification && (
						<ConfirmationNotification
							header={this.state.notificationHeader}
							body={this.state.notificationBody}
							confirmFunction={
								this.state.notificationConfirmFunction
									? () => {
										this.state.notificationConfirmFunction();
										this.closeConfirmationHandler();
									}
									: null
							}
							closeNotification={this.closeConfirmationHandler}
						/>
					)}
				</AnimatePresence>
			</div >
		);
	}
}

export default withRouter(AdminCore);
